import { render, staticRenderFns } from "./element-base-info.vue?vue&type=template&id=161caf65"
import script from "./element-base-info.vue?vue&type=script&lang=js"
export * from "./element-base-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports